export default __webpack_public_path__ + "static/media/producto-08.03a77b7f.jpg";